import {useState} from "react";

import {
    LeasePackageCatalogDetailDto,
    SaveLeasePackageCatalogDto,
} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useSaveLeasePackageCatalog() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<LeasePackageCatalogDetailDto>();
    const [error, setError] = useState<Error>();

    async function execute(dto: SaveLeasePackageCatalogDto, id?: number) {
        try {
            setLoading(true);
            setError(undefined);
            const catalog = id === undefined
                ? await createLeasePackageCatalog(dto)
                : await renameLeasePackageCatalog(id, dto);
            setData(catalog);
            return catalog;
        } catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        } finally {
            setLoading(false);
        }
    }

    function reset() {
        setData(undefined);
        setError(undefined);
    }

    return {loading, data, error, execute, reset};
}

export async function createLeasePackageCatalog(
    dto: SaveLeasePackageCatalogDto,
): Promise<LeasePackageCatalogDetailDto> {
    const response = await customAxios.post<LeasePackageCatalogDetailDto>("/v1/lease-package-catalogs", dto);
    return response.data;
}

export async function renameLeasePackageCatalog(
    id: number,
    dto: SaveLeasePackageCatalogDto,
): Promise<LeasePackageCatalogDetailDto> {
    const response = await customAxios.put<LeasePackageCatalogDetailDto>(`/v1/lease-package-catalogs/${id}`, dto);
    return response.data;
}
